// Shared so recoverClipped.ts's emitter and the HTML-viewer's reveal selector can't drift apart.
export const RECOVERED_CLIPPED_ATTR = 'data-recovered';
export const RECOVERED_CLIPPED_VALUE = 'clipped-overflow';
//# sourceMappingURL=htmlRecoveredMarker.js.map